import { EInvoiceIneligibilityReason } from '@features/invoices/enums/eInvoiceIneligibilityReason'

export const eInvoiceIneligibilityReasonToTranslationKey: Record<EInvoiceIneligibilityReason, string> = {
  [EInvoiceIneligibilityReason.ClientNotCompany]:
    'external_invoices.editor.side_actions.send_as_e_invoice_ineligibility.client_not_company',
  [EInvoiceIneligibilityReason.ClientNotFrench]:
    'external_invoices.editor.side_actions.send_as_e_invoice_ineligibility.client_not_french',
  [EInvoiceIneligibilityReason.ClientNotPrivate]:
    'external_invoices.editor.side_actions.send_as_e_invoice_ineligibility.client_not_private_entity',
}
